import React from 'react';

interface ValidationResult {
  success: boolean;
  message?: string;
}

interface TextareaProps {
  id?: string;
  rows?: number;
  value?: string;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  validationResult?: ValidationResult;
  invalidLabel?: boolean;
  showInvalidLabel?: boolean;
  name?: string;
  className?: string;
  placeholder?: string;
  updateHandler?: (value: string, stateType?: string) => void;
  stateType?: string;
}

const Textarea = ({
  stateType,
  updateHandler,
  rows,
  name,
  value,
  className,
  placeholder,
}: TextareaProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    if (stateType) {
      updateHandler?.(e.target.value, stateType);
    } else {
      updateHandler?.(e.target.value);
    }
  };

  return (
    <textarea
      rows={rows}
      name={name}
      value={value}
      onChange={handleChange}
      className={className}
      placeholder={placeholder}
    />
  );
};

export default Textarea;
